import React from 'react'
import styled, { css } from 'styled-components'
import { CARD_WIDTH, CARD_HEIGHT } from 'global'
import { Box, IBoxProps } from 'components'

interface ICardProps {
  children?: React.ReactNode
  height?: number
  width?: number
  transparent?: boolean
  scale?: string
  outerProps?: IBoxProps
  innerProps?: IBoxProps
}

export interface ICardOuterFrameProps extends IBoxProps {
  transparent?: boolean
}

// Issues with styled-components color and html div element color props not overlapping.
type boxAsFuncComp<T> = React.FunctionComponent<T>

const OuterFrame = styled(Box)<ICardOuterFrameProps>`
  border-radius: 6px;
  background-color: #fff;
  ${({ transparent }) =>
    css`
      ${transparent &&
      css`
        background-color: transparent;
        border: none;
      `}
    `}
` as boxAsFuncComp<ICardOuterFrameProps>

const InnerFrame = styled(Box)<IBoxProps>`
  border-radius: 6px;
  height: 100%;
  position: relative;
` as boxAsFuncComp<IBoxProps>

export const Card = ({
  children,
  width = CARD_WIDTH,
  height = CARD_HEIGHT,
  transparent = false,
  outerProps = {},
  innerProps = {},
}: ICardProps) => {
  return (
    <OuterFrame
      padding='12px'
      width={width}
      height={height}
      transparent={transparent}
      // prevent double tap zoom (note touch-action: none | manipulate; is not being respected)
      onClick={(e) => e.preventDefault()}
      {...outerProps}
    >
      <InnerFrame padding={3} {...innerProps}>
        {children}
      </InnerFrame>
    </OuterFrame>
  )
}
